import { Status } from '@app/shared/models/status';
import { NonConformanceType, ProducedMaterialStatus, RemarkType, QaCheckResult } from 'chronos-core-client';

export const LAST_FLAG_STATUS = 'lastFlagStatus';
export interface StatusParameter {
  labelClass: string;
  stripClass?: string;
  size?: string;
  text: string;
}

export interface StatusParameters {
  [statusName: string]: StatusParameter;
}

export const productionOrderStatusFlags: StatusParameters = {
  [Status.Active]: {
    labelClass: 'status--active',
    text: 'STATUS.ACTIVE'
  },
  [Status.Checked]: {
    labelClass: 'status--checked',
    text: 'STATUS.CHECKED'
  },
  [Status.Open]: {
    labelClass: 'status--open',
    text: 'STATUS.RELEASED'
  },
  [Status.Reopened]: {
    labelClass: 'status--open',
    text: 'STATUS.REOPENED'
  },
  [Status.Next]: {
    labelClass: 'status--next',
    text: 'STATUS.NEXT'
  },
  [Status.Finished]: {
    labelClass: 'status--ended',
    text: 'STATUS.ENDED'
  },
  [Status.Interrupted]: {
    labelClass: 'status--ended',
    text: 'STATUS.INTERRUPTED'
  },
  [Status.None]: {
    labelClass: 'status--ended',
    text: 'STATUS.NONE'
  }
};

export const producedMaterialStatusFlags: StatusParameters = {
  [ProducedMaterialStatus.Active]: {
    labelClass: 'status--active',
    text: 'PRODUCED_MATERIAL_STATUS.ACTIVE'
  },
  [ProducedMaterialStatus.Finished]: {
    labelClass: 'status--finished',
    text: 'PRODUCED_MATERIAL_STATUS.FINISHED'
  },
  [ProducedMaterialStatus.None]: {
    labelClass: 'status--none',
    text: 'PRODUCED_MATERIAL_STATUS.NONE'
  },
  [ProducedMaterialStatus.Open]: {
    labelClass: 'status--open',
    text: 'PRODUCED_MATERIAL_STATUS.OPEN'
  },
  [ProducedMaterialStatus.Seed]: {
    labelClass: 'status--seed',
    text: 'PRODUCED_MATERIAL_STATUS.SEED'
  },
  [LAST_FLAG_STATUS]: {
    labelClass: 'status--last',
    text: 'PRODUCED_MATERIAL_STATUS.LAST',
    stripClass: 'status__strip--last'
  }
};

export const taskStatusFlags: StatusParameters = {
  [Status.Downtime]: {
    labelClass: 'status--downtime',
    text: 'STATUS.DOWNTIME'
  }
};

export const shopFloorRemarkFlag = {
  labelClass: 'status--production-order-info-dc',
  translation: 'REMARK_STATUS.PRODUCTION_ORDER_INFO_SHOP_FLOOR'
};

export const remarkStatusFlags: StatusParameters = {
  [RemarkType.ProductionOrderInfoShopFloor]: {
    labelClass: 'status--production-order-info-dc',
    text: 'REMARK_STATUS.PRODUCTION_JOB_INFO_DC'
  },
  [RemarkType.ProductionJobInfoPL]: {
    labelClass: 'status--production-order-info-pl',
    text: 'REMARK_STATUS.PRODUCTION_JOB_INFO_PL'
  },
  [RemarkType.ProductionKpiInfo]: {
    labelClass: 'status--production-order-info-dc',
    text: 'REMARK_STATUS.PRODUCTION_KPI_INFO'
  },
  [RemarkType.ProductionOrderInfoPL]: {
    labelClass: 'status--production-order-info-pl',
    text: 'REMARK_STATUS.PRODUCTION_ORDER_INFO_PL'
  },
  [RemarkType.VirtualContainerInfo]: {
    labelClass: 'status--virtual-container-info',
    text: 'REMARK_STATUS.VIRTUAL_CONTAINER_INFO'
  }
};

export const ncStatusFlags: StatusParameters = {
  [NonConformanceType.Debitor]: {
    labelClass: 'status--client',
    text: 'NC_TYPE.DEBITOR'
  },
  [NonConformanceType.Kreditor]: {
    labelClass: 'status--client',
    text: 'NC_TYPE.KREDITOR'
  },
  [NonConformanceType.Production]: {
    labelClass: 'status--production',
    text: 'NC_TYPE.PRODUCTION'
  }
};

export const palletQualtityStatusFlags: StatusParameters = {
  [QaCheckResult.Ok]: {
    labelClass: 'status__label--ok-active',
    text: 'OK'
  },
  [QaCheckResult.NotOk]: {
    labelClass: 'status__label--nok-active',
    text: 'NOK'
  },
  [QaCheckResult.NotApplicable]: {
    labelClass: 'status__label--na-active',
    text: 'NA'
  },
  [QaCheckResult.WarningOk]: {
    labelClass: 'status__label--wok-active',
    text: 'WOK'
  }
};
